import { AddressDeliveryType } from "../../../models/transportation/enums/addressDeliveryType";
import { Address } from "../../../models/utilities/address";
import { JsonProperty } from "../../../models/utilities/json-property";
import { DeliveryHourView } from "../../../shared/models/ship-to-address-read";

export class PendingAddress {
    public id: number = 0;

    public customerId: string = '';

    public customerName: string = '';

    public name: string = '';

    public phoneNumber: string = '';

    public unloadRate: number | undefined = undefined;

    @JsonProperty({ toClass: Address })
    public address: Address = new Address();

    public isNew: boolean = false;

    @JsonProperty({ toClass: DeliveryHourView, designType: 'array' })
    public deliveryHours: DeliveryHourView[] = [];

    public rowVersion: string = '';

    public isJobSite: boolean = false;

    public contactEmailBusiness: string | null = null;

    public contactNameBusiness: string | null = null;

    public contactPhoneNumberBusiness: string | null = null;

    public contactEmailSite: string | null = null;

    public contactNameSite: string | null = null;

    public contactPhoneNumberSite: string | null = null;

    public note: string | null = null;

    public approvalUser: string | null = null;

    public approvalDate: Date | null = null;

    public reviewUser: string | null = "";

    public reviewedOn: Date | null = null;

    public isReviewed: boolean = false;

    public deliveryTypes: AddressDeliveryType[] = [];

    public orders: PendingAddressOrder[] = [];
}

export class PendingAddressOrder {
    public id: string = '';
    public description: string = '';

    /** Whether the order is sent by Fedex rather than delivered to the address */
    public isFedex: boolean = false;
}